export type TSelectItem = {
  label: string;
  value: number;
  color?: string;
};

export type TSelectOption = {
  value: string;
  label: string;
};

export enum TItemsFilter {
  Tags,
  Sweeps,
}

export enum Mode {
  day = 3,
  week = 7 * 3,
  month = 30 * 3,
}

export enum PAGE_PATH {
  ALL = 'all',
  TOUR = 'tour',
  EXPERIENCE = 'experience',
  ECOMMERCE = 'e-commerce-tour',
  KIOSK = 'kiosk',
}

export type ZoomHandler = (event) => void;

export enum ConditionLocationType {
  sweep = 'sweep',
  tourLink = 'tourLink',
}

export enum GameStatus {
  NotStarted = 'not_started',
  Started = 'started',
  OutroClip = 'outro_clip',
  SuccessfullyEnded = 'successfully_ended',
  SuccessfullyEndedWithoutFinalScreen = 'successfully_ended_without_final_screen',
  SuccessfullyEndedWithSimpleFinalScreen = 'successfully_ended_with_simple_final_screen',
  TimeIsUpEnded = 'timup_ended',
}

interface ThemeProps {
  device: {
    mobile: boolean;
    landscape: boolean;
    ios: boolean;
  };
}

export interface AppStyledProps {
  theme: ThemeProps;
  rtl?: boolean;
}

export enum ExternalProvider {
  SHOPIFY = 'shopify',
  OPTICAL_CENTER = 'opticalCenter',
  HAVELLS = 'havells',
}

export enum vsTriggerType {
  default = 'default',
  revealCondition = 'revealCondition',
}

export enum ShowcaseElement {
  TagPanel = 'TAG_PANEL',
  TagPanelHeader = 'TAG_PANEL_HEADER',
  LoaderPowerBy = 'LOADER_POWER_BY',
  LoaderPresentedBy = 'LOADER_PRESENTED_BY',
  TagEmbedMedia = 'TAG_EMBED_MEDIA',
  ErrorContainer = 'ERROR_CONTAINER',
  VRLayer = 'VR_LAYER',
  AddMeasurement = 'ADD_MEASUREMENT',
}

export type TIoTWebhook = {
  doorName?: string;
  doorAction?: string;
  doorId?: number;
  tourIds?: [number];
  toursVsImageId?: number;
  userName?: string;
};

export enum TreedisSDKEvent {
  TagClicked = 'TagClicked',
  TagFocused = 'TagFocused',
  TagHovered = 'TagHovered',
  TagDocked = 'TagDocked',
}
